import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { servicesApi as r } from "@maat/api-main";
//#region src/services/useCreateServiceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createService(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreateServiceMutation };
